import React, { useState } from "react";
import "./Header.css";
import { CiPower } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../components/confirm-modal/ConfirmModal";
import { userLogout } from "../../apis/unprotected-apis/authApis";

interface HeaderProps {
  loggedIn: boolean;
  hideAuthButtons?: boolean;
  onLogin: () => void;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({
  loggedIn,
  hideAuthButtons = true,
  onLogout,
}) => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleLogoutClick = () => {
    setModalOpen(true);
  };

  const handleLogout = async () => {
    
    try {
      const res = await userLogout();
      if (res.success) {
        localStorage.removeItem("token");
        localStorage.removeItem("library_card");
        localStorage.removeItem("user");
        localStorage.removeItem("library_name");
        onLogout();
        navigate("/login");
      }
    } catch (error) {
      console.error("Logout API failed:", error);
    }
    setModalOpen(false);
    localStorage.removeItem("token");
  };

  const IconComponent = CiPower as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  return (
    <>
      <div className="custom-header">
        <div
          className="header-left"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img
            src="https://www.sos.wa.gov/sites/default/files/2023-03/sos-logo.svg?uid=6853a16092bb8"
            alt="Washington State Seal"
            className="state-logo"
          />
        </div>
        {hideAuthButtons && (
          <div className="header-right">
            {loggedIn ? (
              <button className="logout-btn" onClick={handleLogoutClick}>
                <strong>Log Out</strong>
                <IconComponent
                  style={{ fontSize: "18px", marginLeft: "0.5rem" }}
                />
              </button>
            ) : (
              <button className="login-btn" onClick={handleLoginClick}>
                Login
              </button>
            )}
          </div>
        )}
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        title="Log Out?"
        message="Are you sure you want to log out?"
        confirmText="Yes, Log Out"
        cancelText="Cancel"
        onConfirm={handleLogout}
        onCancel={() => setModalOpen(false)}
      />
    </>
  );
};

export default Header;
